// extracted by mini-css-extract-plugin
module.exports = {"messageCont":"sendHelp_messageCont__1q2Ih"};